module.exports = __webpack_public_path__ + "assets/img/triangleIcon-f880d6b2.png";